import { Dialog, DialogContent } from '@mui/material';
import { CabecalhoModal } from './cabecalho-modal';
import { LoginConteudo } from './login-conteudo';

/**
 * Login como modal sobreposto à tela atual — ponto único de login do app. NÃO
 * navega: ao concluir, fecha e o chamador segue exatamente de onde parou (ex.: o
 * último passo do checkout), sem remontar a tela nem perder o estado dela.
 *
 * Usado por checkout, menu lateral, conta e meus-pedidos. Para adotar em outra
 * tela, basta controlar `aberto` e tratar `onSucesso` (geralmente só fechar; as
 * queries gateadas por token recarregam sozinhas quando o login grava o token).
 */
export function DialogLogin({
  aberto,
  onFechar,
  onSucesso,
}: {
  aberto: boolean;
  onFechar: () => void;
  onSucesso: () => void;
}): JSX.Element {
  return (
    <Dialog open={aberto} onClose={onFechar} fullWidth maxWidth="xs" scroll="paper">
      <CabecalhoModal titulo="Entrar ou criar conta" aoFechar={onFechar} />
      <DialogContent sx={{ pt: 2, pb: 3 }}>
        <LoginConteudo onSucesso={onSucesso} />
      </DialogContent>
    </Dialog>
  );
}
